// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-heading[data-v-7c2de99d]{padding:24px 0 12px 0;font-size:20px;font-weight:bold;color:var(--color-text-maxcontrast)}`, "",{"version":3,"sources":["webpack://./src/components/Page/LandingPageWidgets/WidgetHeading.vue"],"names":[],"mappings":"AACA,iCACC,qBAAA,CACA,cAAA,CACA,gBAAA,CACA,mCAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
